import { render, staticRenderFns } from "./Char4.vue?vue&type=template&id=3a140ade&"
import script from "./Char4.vue?vue&type=script&lang=js&"
export * from "./Char4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports